import { TRAINING_ZONE_COLORS } from '../../utils/trainingZones';
/** Theme-aware data colors. SVG, legends and tooltips all consume these roles. */
export const CHART_SERIES = {
  primary: 'var(--chart-series-green)',
  secondary: 'var(--chart-series-pink)',
  tertiary: 'var(--chart-series-teal)',
  neutral: 'var(--chart-series-neutral)',
  greenAlt: 'var(--chart-series-green-alt)',
  pinkAlt: 'var(--chart-series-pink-alt)',
  olive: 'var(--chart-series-olive)',
  mauve: 'var(--chart-series-mauve)',
  negative: 'var(--chart-series-negative)',
} as const;

/** Alternate hues before repeating a family. Identity stays stable when series hide. */
export const CATEGORICAL_COLORS = [CHART_SERIES.primary, CHART_SERIES.secondary,
  CHART_SERIES.tertiary, CHART_SERIES.neutral, CHART_SERIES.greenAlt,
  CHART_SERIES.pinkAlt, CHART_SERIES.olive, CHART_SERIES.mauve] as const;

/** A second cue for overlapping curves, shared by plots and legend samples. */
export function seriesStrokeDash(index: number): string | undefined {
  return [undefined, '7 4', '2 4', '10 3 2 3', '12 4', '4 3', '1 3', '8 3 1 3'][(index + Math.floor(index / CATEGORICAL_COLORS.length)) % 8];
}

// Compatibility names for older chart consumers; no independent color literals.
export const BLUE = CHART_SERIES.primary;
export const BLUEL = CHART_SERIES.primary;
export const PINK = CHART_SERIES.secondary;
export const PINKL = CHART_SERIES.secondary;
export const GREEN = CHART_SERIES.primary;
export const GREENL = CHART_SERIES.greenAlt;
export const CYAN = CHART_SERIES.tertiary;
export const GOLD = CHART_SERIES.olive;
export const EMBER = CHART_SERIES.negative;
export const VIOLET = CHART_SERIES.neutral;

export const [Z1C, Z2C, Z3C, Z4C, Z5C] = TRAINING_ZONE_COLORS;
export const ZONE_COLORS = TRAINING_ZONE_COLORS;
export const DONUT_PALETTE = CATEGORICAL_COLORS;
export const SPORT_COLORS: Record<string, string> = {
  bike: CHART_SERIES.primary, cycling: CHART_SERIES.primary,
  run: CHART_SERIES.secondary, running: CHART_SERIES.secondary,
  swim: CHART_SERIES.tertiary, swimming: CHART_SERIES.tertiary,
  strength: CHART_SERIES.neutral, ski: CHART_SERIES.olive,
  'mtn-bike': CHART_SERIES.greenAlt, other: CHART_SERIES.mauve,
};

export const PMC_COLORS = {
  ctl: 'var(--chart-pmc-ctl)', atl: 'var(--chart-pmc-atl)',
  tsbPositive: 'var(--chart-pmc-tsb-positive)', tsbNegative: 'var(--chart-pmc-tsb-negative)',
} as const;
